const Card = ({ className = "", clickable, children, ...rest }) => {
  const classes = `bg-white ${className ?? ""} ${clickable ? "cursor-pointer" : ""}`.trim();
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};

export default Card;
